import { render, staticRenderFns } from "./outbox.vue?vue&type=template&id=f64bfa4c&scoped=true&"
import script from "./outbox.vue?vue&type=script&lang=js&"
export * from "./outbox.vue?vue&type=script&lang=js&"
import style0 from "./outbox.vue?vue&type=style&index=0&id=f64bfa4c&lang=scss&scoped=true&"
import style1 from "./outbox.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./outbox.vue?vue&type=style&index=2&id=f64bfa4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64bfa4c",
  null
  
)

export default component.exports